import { defineApiActionTypes } from 'store/common/action-helpers';

const prefix = 'features/users/skills';

export const ADD_USER_SKILL = defineApiActionTypes(`${prefix}/ADD`);



// WEBPACK FOOTER //
// ./src/store/features/users/skills/action-types.js